import { Box, Container, useTheme } from "@mui/material";
import { HorizontalScrollList } from "../../horizontal-scroll-list/index.js";
import { SingleProduct } from "../single-product.js";
import { useMediaQuery } from "../../utilities/index.js";
import React from "react";
export const HorizontalScrollLayout = ({ products, showPrice = true, }) => {
    const theme = useTheme();
    const disableGutters = useMediaQuery(theme.breakpoints.down("md"));
    return (React.createElement(Container, { maxWidth: "xl", disableGutters: disableGutters || false, sx: { "&.MuiContainer-disableGutters": { px: 0 } } },
        React.createElement(HorizontalScrollList, { items: 3.15 }, products.map((product) => (React.createElement(Box, { component: "li", key: `related-product-scroll-${product.slug}` },
            React.createElement(SingleProduct, { product: product, showPrice: showPrice })))))));
};
//# sourceMappingURL=horizontal-scroll-layout.js.map